<!-- 模拟iview分页插件 -->
<template>
    <div class="cu-page">
        <span class = 'span1' v-show = 'sumPage.length > 0 && sumPage[0] !== 1' @click = '_pageHandler(1)'>首页</span>
        <span @click = '_pageChange("0")' :class = '[choosedIndex === 1 ? "span_active" : ""]'>&lt;</span>
        <ul>
            <li v-for = 'item in sumPage'
                :key = 'item'
                :class = '[item === choosedIndex ? "active" : ""]'
                @click = '_pageHandler(item)'>
                <a href="javascript:void(0);"
                     :class = '[item === choosedIndex ? "a_active" : ""]'>{{item}}</a>
            </li>
        </ul>
        <span @click = '_pageChange("1")' :class = '[choosedIndex === maxPage ? "span_active" : ""]'>&gt;</span>
    </div>
</template>

<!-- 表示样式部分 -->
<style lang="less" scoped>
    .cu-page {
        margin-top: 20px;
        text-align: center;
        margin-bottom: 20px;
        span {
            cursor: pointer;
            display: inline-block;
            vertical-align: middle;
            min-width: 32px;
            height: 32px;
            line-height: 30px;
            text-align: center;
            font-weight: 500;
            border: 1px solid #dcdee2;
            border-radius: 4px;
            background: #ffffff;
        }
        .span1 {
            width: 45px;
            color: #515a6e;
        }
        .span1:hover {
            border: 1px solid #2d8cf0;
        }
        span:nth-child(1) {
            margin-right: 3px;
        }
        span:nth-child(2) {
            margin-left: 7px;
        }
        .span_active {
            color: #ccc;
        }
        ul {
            display: inline-block;
            .active {
                color: #2d8cf0;
                border: 1px solid #2d8cf0;
            }
            li:hover {
                border: 1px solid #2d8cf0;
            }
            li {
                display: inline-block;
                vertical-align: middle;
                min-width: 32px;
                height: 32px;
                line-height: 30px;
                margin-right: 4px;
                text-align: center;
                list-style: none;
                background-color: #fff;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                cursor: pointer;
                font-family: Arial;
                font-weight: 500;
                border: 1px solid #dcdee2;
                border-radius: 4px;
                transition: border .2s ease-in-out,color .2s ease-in-out;
                a {
                    margin: 0 6px;
                    text-decoration: none;
                    color: #515a6e;
                    font-size: 14px;
                }
                .a_active {
                    color: #2d8cf0;
                }
                a:hover {
                    color: #2d8cf0;
                }
            }
        }
    }
</style>

<!-- 表示js部分 -->
<script>

    // 导出模块
    export default {

        // 名称
        name: 'cu-page',

        // 数据
        data: function() {
            return {

                // 表示当前选中的index
                choosedIndex: 1,
                // 表示总的页数
                sumPage: [],
                // 表示最多显示页数
                defaultMaxPage: 6,
                // 表示最大页数
                maxPage: 0
            }
        },

        // 参数
        props: {

            // 表示记录总数
            total: {
                type: Number,
                default: 0
            },

            // 表示当前页数
            current: {
                type: Number,
                default: 0
            },

            // 表示每页条数 默认每页10条数据
            pageSize: {
                type: Number,
                default: 10
            }
        },

        // 监听方法
        watch: {

            // 监听总数变化 算出页数
            total: {
                handler: function(newVal, oldVal) {

                    // 判断总数是否是0
                    if (this.total === 0 || newVal === oldVal) return false;
                    this._sumPageComputed();
                },
                immediate: true
            },

            /**
             * @author lihh
             * @description 监听页数
             */
            current: {
                handler: function() {

                    // 判断页数是否为第一页
                    if (this.current !== 1) return false;
                    this.choosedIndex = 1;
                    this._sumPageComputed();
                },
                immediate: true
            }
        },

        // 方法
        methods: {

            /**
             * @author lihhh
             * @description 根据总的条数 计算当前的页数
             * @param currentPage 表示从哪开始计算
             */
            _sumPageComputed: function(currentPage = 1) {

                // 解构数据
                let {
                    total,
                    pageSize,
                    defaultMaxPage
                } = this;

                // 表示计算总数
                let sumPage = Math.ceil(total / pageSize);
                this.maxPage = sumPage;

                // 当前页数是1页 || 最大页数 <= 默认页数
                if (currentPage === 1 || sumPage <= defaultMaxPage) {
                    
                    this.sumPage = [];
                    // 循环页数 以最小页数为准
                    let forPage = sumPage <= defaultMaxPage ? sumPage : defaultMaxPage;
                    for (let i = 0; i < forPage; i ++) this.sumPage.push((i + 1));
                    return false;
                }

                // 当前页数 + 默认页数是否 > 最大页数 && 当前页数 < 最大页数
                // 表示还有页数 但是不足一个默认数
                if ((currentPage + defaultMaxPage) > (sumPage)
                    && (currentPage <= sumPage)) {

                        this.sumPage = [];
                        currentPage = sumPage - defaultMaxPage + 1;
                        for (let i = currentPage; i < (sumPage + 1); i ++) this.sumPage.push((i));
                        return false;
                    }

                // 当前页数 + 默认页数是否 > 最大页数
                if ((currentPage + defaultMaxPage) > (sumPage + 1)) return false;

                this.sumPage = [];
                let forPage = currentPage + defaultMaxPage;
                for (let i = currentPage; i < forPage; i ++) this.sumPage.push((i));

            },

            /**
             * @author lihh
             * @description 表示点击页数
             * @param page 表示页数
             */
            _pageHandler: function(page) {

                // 设置选中状态 重新计算 给父类传递值
                page = Number(page);
                this.choosedIndex = page;
                this._sumPageComputed(page);
                this.$emit('on-change', page);
            },

            /**
             * @author lihh
             * @description 箭头点击进行分页
             * @param type 表示加 或是 减
             */
            _pageChange: function(type) {

                // 解构数据
                let {
                    total,
                    pageSize
                } = this;
                // 总页数
                let sumPage = Math.ceil(total / pageSize);
                // 进行临界值判断
                if ((type === '0' && this.choosedIndex === 1)
                    || (type === '1' && this.choosedIndex === sumPage)) return false;

                // 分页箭头点击
                this._pageHandler(type === '0' ? -- this.choosedIndex : ++ this.choosedIndex);
            }
        },

        // 表示组件创建钩子函数
        created: function() {

            // this._sumPageComputed();
        }
    }
</script>


// WEBPACK FOOTER //
// src/packages/Page/CuPage/Cu-Page.vue